import {useDispatch} from 'react-redux';
import apiClient from '.';
import useAuthorizationContext from '../hooks/authorizationContext/useAuthorizationContext';
import {setUserRole} from '../redux/slices/analyticsSlice';
import {ErrorRes, Permission} from '../types/types';
import {getUserRoleForGA} from '../utils/analyticsUtils';
import {defineAbilitiesFor} from '../utils/authorization';
import {setLoggedInUserRoles} from '../redux/slices/userRoleSlice';

function useAuthorizationService() {
  const ability = useAuthorizationContext();
  const dispatch = useDispatch();

  async function authorize() {
    const permissions = await getPermissions();
    const abilities = defineAbilitiesFor(permissions);
    ability.update(abilities.rules);
  }

  async function getPermissions() {
    try {
      const response = await apiClient.get(
        `v1/clientmanagement/userpermissions`
      );

      const userRoles = response?.data?.data?.value?.userRole || [];
      dispatch(setLoggedInUserRoles(userRoles));
      const gaRole = await getUserRoleForGA(userRoles);
      dispatch(setUserRole(gaRole));
      const permissions = response.data.data.value.permissions as Permission[];
      return permissions;
    } catch (error: unknown) {
      const e = error as ErrorRes;
      throw new Error(e.response?.data?.validationErrors?.email);
    }
  }

  return {authorize};
}

export {useAuthorizationService};
